export const BOOTSTRAP_CURRENT_USER = 'BOOTSTRAP_CURRENT_USER'
export const LOAD_USERS = 'LOAD_USERS'
export const LOAD_USER = 'LOAD_USER'
export const ADD_USER = 'ADD_USER'
export const SET_USER = 'SET_USER'